
const LAYOUT_DEFAULT = {
  title: "Título da página",
  primaryInformation: "Bem vindo!",
  secondaryInformation: "Responda a pesquisa e ganhe 20MB",
  icon: "https://s3-us-west-2.amazonaws.com/artemis-hml-files-static.mobicare.com.br/campaigns/6a55348f-ce16-4159-9fc1-57effcf9c2ce/595066d2-1092-4f3b-9c9a-d41a010ad9f7.png",
  primaryColor: "rgb(255, 109, 0)",
  secondaryColor: "rgb(255, 109, 0)"
}

class CampaignRender {
  
  layout;

  init(layout = null) {
    if(layout){
      this.layout = layout;
    } else {
      this.layout = LAYOUT_DEFAULT;
    }
  }

  renderMedia(){}
  
  renderForm(){}
  
  renderSuccess(){}
}

export default CampaignRender;